/**
 * MainContent Component - Main content area with map, documentation, orders, customers, or tasks
 */
import React from 'react';
import { MapView } from '../Map/MapView';
import { DocumentationView } from '../Documentation/DocumentationView';
import { OrdersView } from '../Orders/OrdersView';
import CustomersView from '../Customers/CustomersView';
import { TasksView } from '../Tasks/TasksView';
import { CustomerSearchView } from '../Search/CustomerSearchView';
import { useViewStore } from '../../store/viewStore';
import './MainContent.css';

export const MainContent: React.FC = () => {
  const { viewMode } = useViewStore();

  const renderView = () => {
    switch (viewMode) {
      case 'map':
        return <MapView />;
      case 'documentation':
        return <DocumentationView />;
      case 'orders':
        return <OrdersView />;
      case 'customers':
        return <CustomersView />;
      case 'tasks':
        return <TasksView />;
      case 'customer-search':
        return <CustomerSearchView />;
      default:
        return <MapView />;
    }
  };

  return (
    <main className="main-content">
      {renderView()}
    </main>
  );
};

